import WithHeaderAds from "../../Layout/WithHeaderAds";
import NotFound from "../../Illustrations/undraw_page_not_found_su7k.svg";
import SEO from "../../Seo";

const Page = () => {
  return (
    <WithHeaderAds>
      <SEO
        text={`404 | Online JavaScript Practice Ground | Learnersbucket`}
        description={`Ace your JavaScript interviews by practicing System Design, Frontend Interview questions on learnersbucket.com, it requires no signup and works offline as well.`}
      />
      <h1>OOPs!, We don't have what you are looking for.</h1>
      <br />
      <img
        src={NotFound}
        alt="Not Found"
        style={{ display: "inline-block", width: "70%" }}
      />
    </WithHeaderAds>
  );
};

export default Page;
